import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { timeStamp } from 'console';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map, retry, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class TransactionsService {
  
    constructor(private http: HttpClient,  private miscService: MiscService) { }

    getMerchantTransactions = (timestamp) => this.http.get(`${environment.API_URL}/merchants/products/outstanding/${this.miscService.getMerchantDetails().merchant_id}/${timestamp}`).pipe(retry(3))

    getMTBCardTransactions = (timestamp, startDate, endDate) => {
      let params = new HttpParams();
      params = params.append("startDate", startDate);
      params = params.append("endDate", endDate);

      return this.http.get(`${environment.API_URL2}/transactions-service/merchant/outstanding/${this.miscService.getMerchantDetails().merchant_id}/${timestamp}/CARD_TRANSACTIONS/v2`, {params}).pipe(retry(3))
    }

    getNonCardTransactions = (timestamp, startDate, endDate) => {
      let params = new HttpParams();
      params = params.append("startDate", startDate);
      params = params.append("endDate", endDate);
      return this.http.get(`${environment.API_URL2}/transactions-service/merchant/outstanding/${this.miscService.getMerchantDetails().merchant_id}/${timestamp}/NON_CARD_TRANSACTIONS/v2`, {params}).pipe(retry(3))
    }

    getAccountManagementFees = (startDate,endDate) =>{
      let params = new HttpParams();
      params = params.append("startDate", startDate);
      params = params.append("endDate", endDate);
      return this.http.get(`${environment.API_URL2}/transactions-service/merchant/outstanding/${this.miscService.getMerchantDetails().merchant_id}/card-management-fees`, {params}).pipe(retry(3))
    }

    getMovedProductsBreakdown = (process_id) =>{
      return this.http.get(`${environment.API_URL2}/transactions-service/merchant/outstanding/${this.miscService.getMerchantDetails().merchant_id}/${process_id}`).pipe(retry(3))
    }

    // getOutstandingAccount = (timestamp) => this.http.get(`${environment.API_URL2}/transactions-service/merchant/outstanding/${this.miscService.getMerchantDetails().merchant_id}/${timestamp}/NON_CARD_TRANSACTIONS`).pipe(retry(3))
    
    cardMoveToBank = (payload: any, start_date?: any, end_date?: any): Observable<any> => {
      let url = `${environment.API_URL2}/transactions-service/merchant/update-card-transactions/${this.miscService.getMerchantDetails().merchant_id}/v2`;
      
      if(start_date && end_date) {
        url = `${url}?startDate=${start_date}&endDate=${end_date}`;
      }
  
      return this.http.patch(url, payload);
    }
    
    fetchSettledCardTransactions = (startDate: string, endDate: string): Observable<any> => this.http.get(`${environment.API_URL2}/transactions-service/merchant/settled/card-transactions?merchantId=${this.miscService.getMerchantDetails().merchant_id}&startDate=${startDate}&endDate=${endDate}`).pipe(retry(3))

    createMoveToBankRequest = (requestBody) => this.http.post(`${environment.API_URL}/process`, requestBody)
     
    createMoveToBankRequestForBulk = (requestBody) => this.http.post(`${environment.API_URL}/bulk-process`, requestBody)

    moveToBank = (requestBody) => this.http.post(`${environment.API_URL}/movetobank`, requestBody)

    fetchDebit = (productId) => this.http.get(`${environment.API_URL}/products/debits/${productId}`).pipe(retry(3))

    notifyAuthorizers = (requestBody) => this.http.post(`${environment.MERCHANT_AUTH_URL}/api/authorizer/notify-v2`, requestBody)

    // notifyAuthorizers2 = (requestBody) => this.http.post(`${environment.MERCHANT_AUTH_URL}/api/authorizer/notify-v2`, requestBody)

    fetchAidAmount = (merchant_id: string): Observable<any> => this.http.get(`${environment.API_URL2}/transactions-service/merchant/gift-aid-amount/${merchant_id}`).pipe(retry(3));

    createAidAmount = (payload: any): Observable<any> => this.http.post(`${environment.API_URL2}/transactions-service/merchant/gift-aid-amount`, payload);

    updateAidAmount = (payload: any): Observable<any> => this.http.patch(`${environment.API_URL2}/transactions-service/merchant/gift-aid-amount`, payload);

    checkSignatures = (paymentId) => this.http.get(`${environment.MERCHANT_AUTH_URL}/api/authorizers/validate/${this.miscService.getMerchantDetails().merchant_id}/${paymentId}`).pipe(retry(3))
    
    deleteAuthorizer = (paymentId): Observable<any> => this.http.delete(`${environment.MERCHANT_AUTH_URL}/api/authorizers/${this.miscService.getMerchantDetails().merchant_id}/${paymentId}`) ;

    resendAuthorizationEmail = (payload: any): Observable<any> => this.http.post(`${environment.MERCHANT_AUTH_URL}/api/authorizer/resend-notifications`, payload); 

exportSettledCardTransactions(merchantId: string, settledDate: string): Observable<Blob> {
  const url = `${environment.API_URL2}/transactions-service/merchant/settled/card-transactions/export`;
  const params = new HttpParams()
    .set('merchantId', merchantId)
    .set('settledDate', settledDate);

  return this.http.get(url, {
    params: params,
    responseType: 'blob', 
  });
}

// In transactions.service.ts

exportMoveToBankTransactions(merchantId: string, processId: string): Observable<Blob> {
  const url = `${environment.API_URL2}/transactions-service/merchant/settled/xcel-transactions/export`;
  const params = new HttpParams()
    .set('merchantId', merchantId)
    .set('process_id', processId);

  return this.http.get(url, {
    params: params,
    responseType: 'blob'
  });
}
}